import { useCallback } from "react";

import { API_BASE_URL } from "@/api/api.config";
import useRestMutation from "@/remoteState/useRestMutation";

const useTeacherSubjectPost = (defaultId) => {
  const setTeacher = useCallback(
    ({ teacher_id: teacherId = defaultId, ...payload }) => {
      return new Request(
        `${API_BASE_URL}/api/v2/teacher-subjects/${teacherId}/`,
        {
          method: "POST",
          body: JSON.stringify(payload),
          headers: { "Content-Type": "application/json" },
        },
      );
    },
    [],
  );

  return useRestMutation(setTeacher);
};

export default useTeacherSubjectPost;
